<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import CustomInteractionDefault from './CustomInteractionDefault.svelte';
    import { __ } from '@oat-sa-private/ui-core';

    let props = $props();
    // svelte-ignore state_referenced_locally
    let { properties } = props;

    // Provide the host locale to the PCI, in case it is configured to use it
    properties.locale = properties.locale || __.getLocale();
</script>

<CustomInteractionDefault {...props} />
